import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridColumn as Column } from "@progress/kendo-react-grid";
import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { HttpService, SystemGrid } from '../library';
import { SystemDashboardLayout, SystemPanel } from 'library';

const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "TAXBLE_ENTITY_ID",
            operator: "contains",
            value: "",
        },
    ],
};
const DeductionMedical = () => {
    const [filter, setFilter] = useState(initialFilter);
    const [refreshCounter, serRefreshCounter] = useState(0);

    const [reportData, setReportData] = useState({});
    const _export = React.useRef(null);
    const excelExport = (event) => {
        //_export.current.props.data.forEach(cell => {
        //    cell.format = '@';
        //});

        if (_export.current !== null) {
            _export.current.save();
        }
    };

    const getReportData = async () => {
        await HttpService.get("Report/MedicalDeductionContributionReport").then((response) => {
            let formattedData = formatCurrencyData(response.data.Data);
            setReportData(formattedData);
        })
    }

    useEffect(() => {
        getReportData();
    }, [])

    const onRefresh = () => {
        serRefreshCounter(refreshCounter + 1);
    }

    /**
    * @author:Sandeep Sirohi
    * @description: format number with decimal places for the report.
    */
    const numberFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const formatCurrencyData = (data) => {
        return data.map((item) => ({
            ...item,
            CONTRIBUTIONS_TOTAL: `$${item.CONTRIBUTIONS_TOTAL.toFixed(2)}`, // Format as currency with "$"
            DEDUCTIONS_TOTAL: `$${item.DEDUCTIONS_TOTAL.toFixed(2)}`  // Format as currency with "$"
        }));
    };


    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Medical Deduction/Contribution Summary Report" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">
                        <div className="col-md-12">
                            <section className="tile-wrapper row">
                                <div className="container-fluid containerpadding row security-tile-mobile">
                                    <fieldset className="fieldsetGridAndForm">
                                        <SystemPanel label="Report"
                                            toolbar={[<button key={Math.random()} className="btn btn-default" onClick={excelExport}> <span class="icon-download"></span> Download</button>]} showAdd={false} showRefresh={true} showArchive={false} onRefresh={onRefresh}>
                                            <ExcelExport data={reportData} ref={_export}
                                                fileName="MedicalSummary.xlsx" >
                                                <SystemGrid
                                                    refresh={onRefresh}
                                                    dataSource="Report/MedicalDeductionContributionReport">
                                                    <Column field="TAXBLE_ENTITY_ID" title="Taxable Entity ID" width="auto" />
                                                    <Column field="EMPL_ID" title="Employee ID" width="auto" />
                                                    <Column field="FIRST_NAME" title="First Name" width="auto" />
                                                    <Column field="LAST_NAME" title="Last Name" width="auto" />
                                                    <Column key={1} field="CONTRIBUTIONS_TOTAL" title="Field Name" headerClassName="text-center" cell={(props) => (
                                                        <td style={{ textAlign: "right" }}>${numberFormatter.format(props.dataItem.CONTRIBUTIONS_TOTAL)} </td>)
                                                    } />
                                                    <Column key={1} field="DEDUCTIONS_TOTAL" title="Field Name" headerClassName="text-center" cell={(props) => (
                                                        <td style={{ textAlign: "right" }}>${numberFormatter.format(props.dataItem.DEDUCTIONS_TOTAL)} </td>)
                                                    } />
                                                </SystemGrid>
                                            </ExcelExport>
                                        </SystemPanel>
                                    </fieldset>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default DeductionMedical;